
import { mapGetters, mapState } from "vuex";
import WordActions from "@/components/results/WordActions/WordActions.vue";
import Definition from "@/components/results/Definition/Definition.vue";
import { getWordDefinition } from "@/common/services/wordDefinitionService";

export default {
	name: "PlayableCard",
	components: {
		Definition,
		WordActions,
	},
	data() {
		return {
			definition: "",
			definitionType: "",
			definitionLoading: false,
		};
	},
	async fetch() {
		if (!this.isScrabbleDictionaryResultsPage) {
			return;
		}

		this.definitionLoading = true;
		const { sense, partOfSentence } = await getWordDefinition(
			this.$axios,
			this.$config,
			this.word
		);
		this.definitionLoading = false;
		this.definition = sense;
		this.definitionType = partOfSentence;
	},
	computed: {
		...mapGetters("navigation", [
			"isPersistentSearch",
			"isScrabbleDictionaryResultsPage",
			"isNYTCrossplayDictionaryResultsPage",
		]),
		...mapState("query", {
			results: (state) => state.cache.results,
			match: (state) => {
				if (!Object.keys(state.cache.match).length) {
					return null;
				}

				return {
					word: state.cache.match?.word,
					score: state.cache.match?.scores[0],
					bonus: state.cache?.match?.bonus?.[0],
					mod: state.cache.match?.mod,
					has_definition:
						state.cache.match?.scores[
							state.cache.match?.scores.length - 1
						] === 1,
				};
			},
		}),
		isPlayable() {
			return this.match !== null;
		},
		showDefinition() {
			return this.isScrabbleDictionaryResultsPage && this.isPlayable;
		},
		word() {
			return this.match?.word || this.$route.params.tiles || "";
		},
		iconClass() {
			return this.isPlayable
				? "wficon-ok-circled"
				: "wficon-warning-circle";
		},
		message() {
			const parts = [
				`<strong class="block md:inline">${this.word}</strong>`,
			];
			let secondPart = this.isPlayable
				? `is playable for ${
						this.match?.score + (this.match?.bonus || 0)
				  } points`
				: "is not playable";
			if (this.isScrabbleDictionaryResultsPage) {
				secondPart = this.isPlayable
					? `is a playable scrabble word for ${this.match?.score} points`
					: `is not a playable scrabble word`;
			}

			if (this.isNYTCrossplayDictionaryResultsPage) {
				secondPart = this.isPlayable
					? `is a playable Crossplay word for ${this.match?.score} points`
					: `is not a playable Crossplay word`;
			}

			parts.push(secondPart);
			return parts.join(" ");
		},
		messageElement() {
			if (
				this.isScrabbleDictionaryResultsPage ||
				this.isNYTCrossplayDictionaryResultsPage
			) {
				return "h1";
			}

			return "p";
		},
	},
};
